import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { UserRankingItem } from './UserRankingItem';
import React from 'react';

interface UserRankingWidgetProps {
  data?: Array<{
    userName: string;
    deliveredCount: number;
  }>;
}

export const UserRankingWidget: React.FC<UserRankingWidgetProps> = ({
  data = [],
}) => {
  const maxCount = data[0]?.deliveredCount ?? 1;

  return (
    <div className='bg-white rounded-2xl shadow-lg border border-slate-100 p-8 h-full flex flex-col hover:shadow-2xl transition-all duration-300 group'>
      <div className='flex items-center gap-3 mb-6'>
        <div className='p-3 rounded-xl bg-blue-100 text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all duration-500'>
          <EmojiEventsIcon className='!w-5 !h-5' />
        </div>
        <div>
          <h3 className='text-base font-bold text-slate-500 uppercase tracking-wider'>
            Ranking de Usuarios
          </h3>
          <p className='text-sm text-slate-400 mt-0.5 font-medium'>
            Más pedidos entregados
          </p>
        </div>
      </div>

      <div className='flex-1 min-h-0 max-h-[400px] overflow-y-auto pr-1 scroll-smooth [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-slate-100/50 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-thumb]:bg-slate-300 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:min-h-8 hover:[&::-webkit-scrollbar-thumb]:bg-blue-300'>
        <div className='space-y-3 pb-2'>
          {data.length > 0 ? (
            data.map((user, index) => (
              <UserRankingItem
                key={`${user.userName}-${index}`}
                position={index + 1}
                userName={user.userName}
                deliveredCount={user.deliveredCount}
                maxCount={maxCount}
              />
            ))
          ) : (
            <div className='flex flex-col items-center justify-center py-16 text-slate-300'>
              <div className='p-6 bg-blue-50 rounded-full mb-4'>
                <EmojiEventsIcon className='!w-12 !h-12 text-blue-300 opacity-60' />
              </div>
              <p className='text-xs font-black uppercase tracking-widest'>
                Sin datos de ranking
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
